<template>

<div class="buyer-basic-card">
  <div style="height: 40px;">
  <img v-if="currentSession && currentSession.head_url" class="user-avatar" :src="default_img" :onload="loadImg(currentSession.head_url)" :onerror="error_img" >
  <div class="user-meta" style="position: relative;">
    <div class="user-title">
      <div class="user-nickname">
        <font style="vertical-align: inherit;">
          <font v-if="currentSession" style="vertical-align: inherit;">{{ currentSession.title }}</font></font>
      </div>
    </div>
    <div v-if="!buyerInfo.followFlag" @click="follow()" class="user-follow">
      <span>
        <font style="vertical-align: inherit;">
          <font style="vertical-align: inherit;">邀请关注</font></font>
      </span>
    </div>
    <div v-if="buyerInfo.followFlag" class="user-follow">
      <span>
        <font style="vertical-align: inherit;">
          <font style="vertical-align: inherit;color: #999;">已关注店铺</font></font>
      </span>
    </div>
  </div>
  <div v-if="currentSession">
    
    <div v-if="!buyerInfo.presale" @click="addSalesModalShow()" style="margin-left: 50px;font-size: 12px;cursor: pointer;">
      售前备注<Icon color="#0898ff" size="16" type="md-create" />
    </div>
    <div v-if="buyerInfo.presale" @click="editSalesModalShow()" style="margin-left: 50px;font-size: 12px;cursor: pointer;">
      <span style="font-weight: bold;">{{buyerInfo.presale.remark}}</span><Icon color="#0898ff" size="16" type="md-create" />
    </div>
  </div>
  </div>
  <div v-if="false" class="user-section">
    <section>
      <dt>备注</dt>
      <dd>
        <div class="user-note">
          <div style="position: relative;" class="note-edit">
            <div class="note-text">测试123</div>
            <div @click="noteModal = true" style="position: absolute;top: 0px;right: -20px;cursor: pointer;" class="im-icon im-icon-pencil im-icon-xs">
              <Icon color="#0898ff" size="16" type="md-create" />
            </div>
          </div>
        </div>
      </dd>
    </section>
  </div>
  <div class="user-section">
    <section>
      <dt>买家电话</dt>
      <dd>{{buyerInfo.recipient_phone ? buyerInfo.recipient_phone : '-'}}</dd>
    </section>
    <section>
      <dt>配送成功率</dt>
      <dd>{{buyerInfo.successful_delivery_rate ? buyerInfo.successful_delivery_rate : '-'}}</dd>
    </section>
    <section>
      <dt>完成订单数</dt>
      <dd>{{buyerInfo.finish_order_count ? buyerInfo.finish_order_count : '-'}}</dd>
    </section>
    <section v-if="currentSession">
      <dt>是否已读</dt>
      <dd>
        <span style="cursor: pointer;color: #0898ff;" @click="unreadSession" v-if="currentSession.unread_count == 0">标记为未读</span>
      </dd>
    </section>
    <section v-if="currentSession">
      <dt>重新分配</dt>
      <dd>
        <Select v-model="selectUserId" @on-change="transferCsr" filterable>
            <Option :disabled="item.status == 3 ? false : true" v-for="item in childUser" :value="item.id" :key="item.id">{{ item.username }}</Option>
        </Select>
      </dd>
    </section>
  </div>
  <div style="display: none;" class="user-operation">
    <div class="agent-assign-title">
      <button type="button" class="im-components-btn im-components-btn-secondary im-components-btn-small assign">
        <span>
          <font style="vertical-align: inherit;">
            <font style="vertical-align: inherit;">分配</font></font>
        </span>
      </button>
    </div>
    <button style="display: none;" type="button" class="im-components-btn im-components-btn-secondary im-components-btn-small btn-opr">
      <i class="im-components-icon im-components-icon-favorite im-components-icon-xs star-pinner unpinned"></i>
      <i class="im-components-icon im-components-icon-arrow-down im-components-icon-medium im-components-icon-last"></i>
    </button>
  </div>
<Modal
    v-model="noteModal"
    title="添加备注"
    :footer-hide="true"
    width="300"
    >
    <Form :model="formItem" :label-width="100">
      <FormItem label="备注">
          <Input v-model="formItem.textarea" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="Enter something..."></Input>
      </FormItem>
      <FormItem>
          <Button type="primary">确定</Button>
          <Button @onclick="noteModal = false" style="margin-left: 8px">取消</Button>
      </FormItem>
    </Form>
</Modal>  

<Modal 
  v-model="addPsalesModal"
  title="售前备注"
  :footer-hide="true"
  width="400"
  >
   <Form :model="salesForm" :label-width="80">
    <FormItem label="订单类型">
      <Select v-model="salesForm.type" style="width:200px">
            <Option value="1">常规</Option>
            <Option value="2">退款</Option>
            <Option value="3">紧急</Option>
            <Option value="4">补发</Option>
            <Option value="5">私下退换</Option>
        </Select>
    </FormItem>
    <FormItem label="备注">
      <Input v-model="salesForm.remark" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="请输入备注"></Input>
    </FormItem>
    <FormItem>
        <Button @click="preSalesAdd()" type="primary">确定</Button>
    </FormItem>
  </Form>
</Modal>

<Modal 
  v-model="editPsalesModal"
  title="售前备注"
  :footer-hide="true"
  width="400"
  >
   <Form :model="editsalesForm" :label-width="80">
    <FormItem label="备注">
      <Input v-model="editsalesForm.remark" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="请输入备注"></Input>
    </FormItem>
    <FormItem>
        <Button @click="preSalesEdit()" type="primary">确定</Button>
    </FormItem>
  </Form>
</Modal>

</div>

</template>
<script>
import conf from "../../conf";
import RequestUtils from "@/utils/RequestUtils";

export default {
  data() {
    return {
      default_img: require("../../../../static/img/default_avatar.png"),
      error_img: 'this.src="'+require("../../../../static/img/default_avatar.png")+'";',
      loadImg: (imgSrc) => {
        return 'this.onload=null;this.src='+'"'+imgSrc+'";';
      },
      buyerInfo: {},
      title: '',
      noteModal: false,
      formItem: {
          textarea: ''
      },
      addPsalesModal: false,
      editPsalesModal: false,
      salesForm: {
        id: '',
        type: 1,
        remark: ''
      },
      editsalesForm: {
        id: '',
        remark: ''
      },
      selectUserId: 0
    };
  },
  props: ["chat"],
  created() {
  },
  computed: {
    currentSession: {
      get: function() {
        let seller_id = this.$store.state.lazada.currentStore.seller_id;
        return this.$store.state.lazada.currentSessionData[seller_id];
      }
    },
    seller_id: {
      get: function() {
        return this.$store.state.lazada.currentStore.seller_id;
      }
    },
    childUser: {
      get: function () {
        return this.$store.state.childUser;
      }
    },
  },
  methods: {
    /**
     * 获取买家信息
     * @return {[type]} [description]
     */
    getBuyerInfo () {
      let param = new FormData();
      param.set("store_id", this.$store.state.lazada.currentStore.id);
      param.set("buyer_id", this.currentSession.buyer_id);
      RequestUtils.request(conf.getBuyerInfo(), param).then(json => {
        this.buyerInfo = json;
      })
    },
    /**
     * 售前添加
     * @return {[type]} [description]
     */
    preSalesAdd() {
      this.addPsalesModal = false;
      let param = new FormData();
      param.set("store_id", this.$store.state.lazada.currentStore.id);
      param.set("connector", 'lazada');
      param.set("buyer_id", this.currentSession.buyer_id);
      param.set("buyer_username", this.currentSession.title);
      param.set("remark", this.salesForm.remark);
      param.set("type", this.salesForm.type);

      RequestUtils.request(conf.presalesAdd(), param).then(() => {
        this.salesForm.remark = '';
        this.salesForm.type = 1;        
        this.$Message.success('添加成功!');
        this.getBuyerInfo();
      })
    },
    /**
     * 售前编辑
     * @return {[type]} [description]
     */
    preSalesEdit() {
      this.editPsalesModal = false;
      let param = new FormData();
      param.set("presale_id", this.editsalesForm.id);
      param.set("remark", this.editsalesForm.remark);
      param.set("connector", 'lazada');

      RequestUtils.request(conf.presalesEdit(), param).then(() => {
        this.editsalesForm.remark = '';
        this.$Message.success('修改成功!');
        this.getBuyerInfo();
      })
    },
    /**
     * 售前添加modal
     */
    addSalesModalShow() {
      this.addPsalesModal = true;
    },
    /**
     * 售前编辑modal
     * @return {[type]} [description]
     */
    editSalesModalShow() {
      this.editPsalesModal = true;
      this.editsalesForm.id = this.buyerInfo.presale.id
      this.editsalesForm.remark = this.buyerInfo.presale.remark;
    },
    /**
     * 关注店铺
     * @return {[type]} [description]
     */
    follow () {
      let self = this;
      let param = new FormData();
      param.set("store_id", this.$store.state.lazada.currentStore.id);
      param.set("session_id", this.currentSession.session_id);
      param.set("connector", 'lazada');
      param.set("template_id", 10010);
      RequestUtils.request(conf.sendMessage(), param).then(json => {
        console.log(json);
        let message = {
          message_id: json.message_id,
          template_id: 10010,
          data: {
            'title': JSON.stringify({'en': 'Follow the store'}),
            'iconUrl': self.$store.state.lazada.currentStore.logo_url,
            'desc': self.$store.state.lazada.currentStore.seller_name

          }
        };
        self.$store.commit("lazada/addMessage", message);
      })
    },
    // 标记会话为未读
    unreadSession() {
      let param = new FormData();
      param.set("id", this.currentSession.id);
      RequestUtils.request(conf.unreadCount(), param).then(json => {
        if (json) {
          this.$store.commit("lazada/setCurrentSessionData", json);
          this.$store.commit("lazada/setSessionDataBySid", json);
        }
      })
    },
    /**
     * 转移客服
     * @param  {[type]} user_id [description]
     * @return {[type]}         [description]
     */
    transferCsr (user_id) {
      RequestUtils.webSocketSend('transferCsr', {
        'platform': 'lazada',
        'session_id': this.currentSession.id,
        'admin_id': user_id
      });
      this.selectUserId = 0;
      this.$store.commit("lazada/setCurrentSessionData", '');
    }
  }
};
</script>
<style lang="scss">
@import "@/static/styles/theme";

.buyer-basic-card {
  word-break: break-word;
  background-color: #fff;
  padding: 12px 16px 16px;
  margin-bottom: 8px;
  position: relative;

  section {
    display: table-row;
    margin-top: 16px;
  }

  dt {
    color: #999;
    padding-right: 10px;
    text-align: right;
    white-space: nowrap;
    display: table-cell;
    padding-top: 12px;
  }

  .assign, .btn-opr {
    flex-grow: 1;
    justify-content: center;
    height: auto;
    line-height: 12px;
    padding: 7px;
    flex-basis: 30%;
    border-width: 1px;
  }

  .im-components-btn {
    border-radius: 4px;
    font-size: 13px;
    position: relative;
    display: inline-block;
    font-style: normal;
    font-family: inherit;
    background: transparent;
    cursor: pointer;
    text-align: center;
  }

  .im-components-btn-secondary {
    background-color: #fff;
    border-color: rgba(64,112,244,.5);
    color: #4070f4;
  }

  .user-avatar {
    width: 40px;
    height: 40px;
    border-radius: 100%;
    position: absolute;
    background-color: #faf6f0;
  }

  .user-meta {
    display: flex;
    align-items: center;
    margin-bottom: 6px;
    margin-left: 50px;

    .user-title {
      flex: 1 1;

      .user-nickname {
        display: inline-block;
        font-weight: 700;
      }
    }

    .user-follow {
      color: #4070f4;
      cursor: pointer;
    }
  }

  .user-section {
    display: table;
    font-size: 12px;

    dt {
      text-align: left;
    }

  }

  .user-operation {
    display: flex;
    flex-direction: row;
    margin-right: -10px;
    font-size: 13px;

    .agent-assign-title {
      flex-grow: 1;
      flex-basis: 30%;
      margin-right: 10px;
      display: flex;
      align-items: center;
    }
  }

  .im-injector-assign-banner {
    color: #858b9c;
    background: #f2f3f7;
    margin: 16px -16px -16px;
    padding: 8px;
    border-radius: 0 0 12px 12px;
    font-size: 12px;
    text-align: center;
  }
}
</style>
